import React from 'react';
import { X } from 'lucide-react';
import AssetFormFields from './AssetFormFields';
import AssetImageUpload from '../../components/AssetImageUpload';
import AssetImagePreview from '../../components/AssetImagePreview';

const AssetEditModal = ({ assetForm, setAssetForm, editingAsset, setEditingAsset, updateAsset, loading, setShowEditAsset, resetAssetForm, buildings, buildingsLoading, buildingsError, handleImageRemove, handleImagesChange }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Edit Asset</h2>
          <button onClick={() => { setShowEditAsset(false); setEditingAsset(null); resetAssetForm(); }}
            className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>
        <AssetFormFields
          assetForm={assetForm}
          setAssetForm={setAssetForm}
          buildings={buildings}
          buildingsLoading={buildingsLoading}
          buildingsError={buildingsError}
        />
        <div className="mt-4 space-y-4">
          <label className="block text-sm font-medium text-gray-700">Asset Images</label>
          {assetForm.images && assetForm.images.length > 0 && (
            <div>
              <h4 className="text-sm font-medium text-gray-600 mb-2">Current Images</h4>
              <AssetImagePreview
                images={assetForm.images}
                onImageRemove={handleImageRemove}
                onImageView={() => {}}
                editable={true}
              />
            </div>
          )}
          <div>
            <h4 className="text-sm font-medium text-gray-600 mb-2">
              {assetForm.images && assetForm.images.length > 0 ? "Add More Images" : "Upload Images"}
            </h4>
            <AssetImageUpload
              images={assetForm.images || []}
              onImagesChange={handleImagesChange}
              maxImages={5}
              disabled={loading}
            />
          </div>
          <p className="text-xs text-gray-500">Upload up to 5 images per asset. Supported formats: JPEG, PNG, WebP (max 5MB each)</p>
        </div>
        <div className="flex gap-3 pt-4">
          <button onClick={() => { setShowEditAsset(false); setEditingAsset(null); resetAssetForm(); }}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">Cancel</button>
          <button onClick={updateAsset} disabled={loading}
            className="flex-1 text-white px-4 py-2 rounded-lg hover:opacity-90 disabled:opacity-50"
            style={{ backgroundColor: "#00C5CB" }}>
            {loading ? "Updating..." : "Update Asset"}
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default AssetEditModal;
